/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import { Center } from 'chakra-v3';
import { Button, Text } from '../components/Index';
import { useNavigate } from 'react-router-dom';

interface ErrorDisplayProps {
  message: string;
  debugMessage?: string;
  navigateButton?: {
    to: string;
    label: string;
  };
}
function ErrorDisplay(props: ErrorDisplayProps) {
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (props.navigateButton) {
      void navigate(props.navigateButton.to);
    }
  };
  return (
    <Center p="24px" height="100%" flexDirection="column" gap="16px">
      <Text variant="heroHeading" color="text.primary">
        {props.message}
      </Text>

      {props.debugMessage && import.meta.env.DEV && (
        <Text variant="heroSubheading" color="text.accent" whiteSpace="pre-wrap">
          {props.debugMessage}
        </Text>
      )}

      {props.navigateButton && <Button onClick={handleNavigate}>{props.navigateButton.label}</Button>}
    </Center>
  );
}

export default ErrorDisplay;
